import uuid from 'react-native-uuid';

export function getUuid() {
  return uuid.v4();
}
